import { useRef, useState } from "react";
import DialogEngine from "../../../components/dialog/dialog-engine";
import CheckBox from "../../../components/UI/Input/checkbox-radio/check-box-ctrl";
import RadioButton from "../../../components/UI/Input/checkbox-radio/radio-button-ctrl";
import MicroLoader from "../../../components/UI/loader/micro-loader";
import { ModalType } from "../../../shared/GlobalVar";
import { getSecurityDepositPolicy } from "../../../shared/json/data";
import { formatCurrency } from "../../../shared/utility";
import { PaymentCard } from "../../../shared/utility/enum-utility";

const SecurityDepositRate = (props) => {
  const {
    isError,
    confirmSecurityDepositRate,
    setConfirmSecurityDepositRate,
    showSecurityLoader,
    securityDepositData,
    setSecurityDepositData,
    disabled
  } = props;
  const iconRef = useRef(null);
  const [modalData, setModalData] = useState(null);
  const openModal = () => {
    setModalData(
      {
        modalType: ModalType.COMMON_NOTES_MODAL,
        modalProps: {
          showModal: true,
          isDraggable: true,
          closeModal: onCloseModal,
          modalTitle: "Security Deposit Policy",
          modaWrapperClass: "protection-addons-modal"
        },
        modalBodyProps: {
          notes: getSecurityDepositPolicy(),
        },
      }
    );
  }
  const onCloseModal = () => {
    setModalData(null);
  }
  const onPaymentCardChange = (event) => {
    if (event) {
      const tempData = { ...securityDepositData };
      tempData.selectedCardType = event?.target?.value;
      setSecurityDepositData(tempData);
    }
  }
  const securityDepositRate = securityDepositData?.selectedCardType === PaymentCard.CREDIT ? securityDepositData?.ccDeposit
    : securityDepositData?.selectedCardType === PaymentCard.DEBIT ? securityDepositData?.dcDeposit : 0;
  return (
    <div className="common-res-container">
      <div className="flex-row gap-1" style={{ display: "none" }}>
        <div className="title-container">
          <span class="common-title">Payment Card</span>
        </div>
        <div className="sec-charges flex-row gap-1">
          <RadioButton
            name="payment-card-group"
            title="Credit"
            radioLbl="Credit"
            checked={securityDepositData?.selectedCardType === PaymentCard.CREDIT}
            onChange={onPaymentCardChange}
            value={PaymentCard.CREDIT}
            disabled={!securityDepositData?.ccDeposit || disabled}
          />
          <RadioButton
            name="payment-card-group"
            title="Debit"
            radioLbl="Debit"
            checked={securityDepositData?.selectedCardType === PaymentCard.DEBIT}
            onChange={onPaymentCardChange}
            value={PaymentCard.DEBIT}
            disabled={!securityDepositData?.dcDeposit || disabled}
          />
        </div>
      </div>
      <div className="sec-cont position-relative" ref={iconRef}>
        <div className="title-container">
          <span class="common-title">Security Deposit Charges</span>
          <i class="fa fa-info-circle ml-2" aria-hidden="true" title="Click to view Security Deposit Policy" onClick={() => openModal()}></i>
        </div>
        <div className="sec-charges">
          {showSecurityLoader ? <MicroLoader customStyle={{ height: "2rem", width: "2rem" }} />
            : securityDepositRate ? formatCurrency(securityDepositRate) : "--"}

        </div>
        {modalData ?
          <DialogEngine
            {...modalData}
          />
          : ""}
      </div>
      {
        isError && !confirmSecurityDepositRate ? (
          <div className="error-block">
            <i className="fas fa-exclamation-triangle error-icon"></i>
            <div className="main-msg-block">
              <label className="error-title">Required Fields!</label>
              <label className="error-msg">
                {securityDepositRate
                  ? "Please confirm you shared this information with customer."
                  : "Please enter a valid location, country, and Zip/Postal Code for security deposit charges."}
              </label>
            </div>
          </div>
        ) : (
          ""
        )
      }
      {
        confirmSecurityDepositRate !== undefined ? (
          <div>
            <CheckBox
              name="confirmSecurityDepositRate"
              placeholder="I’ve shared security deposit amount with customer."
              checked={confirmSecurityDepositRate}
              onChange={(event) =>
                securityDepositRate &&
                setConfirmSecurityDepositRate(event.target.checked)
              }
              disabled={!securityDepositRate}
              title={
                !securityDepositRate
                  ? "Security deposit charges unavailable."
                  : ""
              }
            />
          </div>
        ) : (
          ""
        )
      }

    </div >
  );
};
export default SecurityDepositRate;